import {Node} from 'tiptap'

export default class Chart extends Node {
  get name() {
    return 'visme'
  }

  get schema() {
    return {
      group: 'block',
      draggable: true,
      selectable: false,
      inline: false,
      attrs: {
        tabindex: {
          default: -1,
        },
        class: {
          default: null,
        },
        dataUrl: {
          default: null,
        },
        dataW: {
          default: null,
        },
        dataH: {
          default: null,
        },
        dataDomain: {
          default: null,
        },
      },
      parseDOM: [
        {
          tag: 'div[class="visme_d"]',
          getAttrs: (dom) => ({
            class: 'visme_d',
            tabindex: dom.getAttribute('tabindex'),
            dataUrl: dom.getAttribute('data-url'),
            'data-url': dom.getAttribute('data-url'),
            dataW: dom.getAttribute('data-w'),
            dataH: dom.getAttribute('data-h'),
            dataDomain: dom.getAttribute('data-domain'),
          }),
        },
      ],
      toDOM: ({attrs}) => ['div', {...attrs}],
    }
  }

  commands({type}) {
    return (attrs) => (state, dispatch) => {
      const {selection} = state
      const position = selection.$cursor
        ? selection.$cursor.pos
        : selection.$to.pos
      const node = type.create(attrs)
      const transaction = state.tr.insert(position, node)
      dispatch(transaction)
    }
  }

  get view() {
    return {
      props: ['node', 'view'],
      computed: {
        class: {
          get() {
            return this.node.attrs.class
          },
        },
        dataUrl: {
          get() {
            return this.node.attrs.dataUrl
          },
        },
        dataW: {
          get() {
            return this.node.attrs.dataW
          },
        },
        dataH: {
          get() {
            return this.node.attrs.dataH
          },
        },
        dataDomain: {
          get() {
            return this.node.attrs.dataDomain
          },
        },
      },
      template: `
        <div class="visme-frame">
          <div class="visme_d" :data-url="dataUrl" :data-w="dataW" :data-h="dataH" :data-domain="dataDomain"></div>
        </div>
      `,
    }
  }
}
